import { CasMRTable, CasMRTCellRenderCurrrency } from 'src/compass/shared/components';
import { CommissionsTabProps } from '../PreliminaryCommissions';
import CommissisonsTotalView from './CommissisonsTotalView';

export default function PreliminaryPayoutsOverviewTab({ data, ...rest }: CommissionsTabProps) {
  const columns = [
    {
      accessorKey: 'source',
    },
    {
      accessorKey: 'description',
    },
    {
      accessorKey: 'total',
      Cell: CasMRTCellRenderCurrrency,
    },
  ];
  return (
    <CasMRTable
      data={data?.result || []}
      columns={columns}
      renderTopToolbarCustomActions={() => CommissisonsTotalView(data?.total)}
      enableGrouping={false}
      enablePagination={false}
      {...rest}
    />
  );
}
